import { render, staticRenderFns } from "./BlogNews.vue?vue&type=template&id=40c2abb2&scoped=true&"
import script from "./BlogNews.vue?vue&type=script&lang=js&"
export * from "./BlogNews.vue?vue&type=script&lang=js&"
import style0 from "./BlogNews.vue?vue&type=style&index=0&id=40c2abb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2abb2",
  null
  
)

export default component.exports